import controller from './procedure-list.controller';
import templateBase from './views/procedure-list.view-t1.html';
import templateAD from './views/procedure-list.adaptative.html';


let ProcedureListComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    categorySlug: "<",
    categoryId : '<',
    productsList : '<',
    typeview : '<'
  }
};


function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}

export default ProcedureListComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/procedure-list/procedure-list.component.js
 **/